// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"0ccf3a7b","16":"604a4184","216":"8154b3b6","288":"85bc630e","592":"35bcfbca","600":"962b5d18","612":"ca84c272","620":"ed53a57e","656":"67cce6c5","704":"21bd2ed2","720":"eee5dd56","736":"2be2bbfc","992":"f01affff"}[chunkId] + ".chunk.js";
};